module.exports = __webpack_public_path__ + "static/winnerIcon-20e48c5e8a5ba716a7b3d25d28768382.png";